import type {IBasicStringConstraint} from '~/components/ProvideForm/utils'
import {notEmpty} from '~/components/ProvideForm/utils'

export const passwordConstraints: IBasicStringConstraint[] = [
  notEmpty,
  {
    constraint: (s: string) => s.length >= 8,
    message: _ => '8 characters minimum',
  },
]
